import React, {useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Label, {FormLabel} from "../../../Utils/FormInputs/Label";
import TextField from "../../../Utils/FormInputs/TextField";
import {titleCase} from "../../../Users/addUser";
import {ReusablePhoneInput} from "../../../Utils/FormInputs/FormGroup";
import {ResizableTextarea} from "../../../Utils/FormInputs/Textarea";
import {CustomSelect} from "../../../Utils/FormInputs/SelectInput";
import {ProviderForm} from "../../../Visit/NewVisit/NewVisit";
import {ErrorMessage} from "../../../Utils/styledComponents";
import {dateConvert} from "../../../Utils/ConvertDate";
import {useAddPrescription} from "../../../DoctorsModule/Prescription/hooks/useAddPrescription";
import axios from "axios";
import {config} from "../../../../Helpers/env";
import {errorMessages, logoutErrorMessage} from "../../../../Helpers/ErrorMessages";
import {convertPhone} from "../../../Utils/convertPhone";
import {history} from "../../../../Helpers/history";
import CustomDialog from "../../../Utils/Dialogs/CustomDialog";
import PrintDialog from "../../../Utils/Dialogs/PrintDialog";
import {NewPrescriptionTable} from "../../../DoctorsModule/Prescription/NewPrescription";
import {FullScreenDialog} from "../../../Utils/Dialogs/FullScreenDialog";
import {AssignBed} from "../../../BedManager/AddEditBedAssign";
import Alert from "@material-ui/lab/Alert";
import {Link} from "react-router-dom";

export const AdmissionForm = ({actions,  match}) =>{
    const {visit_id, patient_number, patient_type} = match

    const user = JSON.parse(sessionStorage.getItem('user'));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const user_roles_id = !_token.user_roles_id ? "" : _token.user_roles_id;
    const department_id = !_token.department_id ? "" : _token.department_id;


    const storage = JSON.parse(sessionStorage.getItem(`${user_roles_id}_${visit_id}`))
    const item = storage ? storage : {}
    const note_item = item[visit_id] ? item[visit_id] : {}

    const guardian_name = note_item['first_name'] ? note_item['first_name'] : ''
    const guardian_address = note_item['address'] ? note_item['address']  : ''
    const guardian_contact = note_item['contact'] ? note_item['contact']  : ''
    const guardian_relationship = note_item['relationship'] ? note_item['relationship']  : ''
    const admission_notes = note_item['notes'] ? note_item['notes']  : ''


    const [state, setState] = useState({admission_date: dateConvert(), first_name: guardian_name, last_name: "",  address: guardian_address, nin: ''});
    const [submitted, setSubmitted] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState('idle');
    const [openDialog, setOpenDialog] = useState(false);
    const [printDialog, setOpenPrintDialog] = useState(false);
    const [patient_admission_id, setAdmissionId] = useState('')
    const [patient_name, setPatientName] = useState('');
    const [contact, setContact] = useState(guardian_contact)
    const [relationship, setRelationship] = useState(guardian_relationship)
    const [provider_id, setProviderId] = useState('')
    const [isProvider, setIsProvider] = useState(null)
    const [providerDetails, setProviderDetails] = useState({account_name:'', card_number:'', provider_type:''})
    const [providers, setProviders] = useState([])
    const [isOnInsurance, setIsOnInsurance] = useState(false)
    const [insurance_status, setInsuranceStatus] = useState('')
    const [insurance_scheme, setInsuranceScheme] = useState([])
    const [insuranceSchemes, setInsuranceSchemes] = useState([])
    const [insuranceDetails, setInsuranceDetails] = useState({})
    const [openAssignBed, setOpenAssignBed] = useState(false)
    const [findings, setAdmissionNotes] = useState(admission_notes);
    const [isAddPrescription, setAddPrescription]= useState(false);

    const {addProps} = useAddPrescription(actions, match);

    const {prescription, other, others} = addProps;

    const { first_name,  address, nin, admission_date} = state;



    useEffect(() => {
        if (!visit_id){
            return
        }
        axios.get(`${config.smsUrl}/cvisit/${visit_id}`).then(res => {
            const data = res.data;
            const dt = !data ? {} : data;
            setInsuranceDetails(dt)
        }).catch(err => {
            logoutErrorMessage(err,null,actions)
        })
    }, [visit_id]);

    useEffect(() => {
        if (!insuranceDetails){

        }
        setInsuranceScheme({value:insuranceDetails?.insurance_scheme_id, label:insuranceDetails?.insurance_scheme_name})
        const isInsurance = insuranceDetails?.is_on_insurance === 1
        setIsOnInsurance(isInsurance)
        setInsuranceStatus(insuranceDetails?.insurance_scheme_status)

    },[insuranceDetails])

    useEffect(() => {
        axios.get(`${config.smsUrl}/cbilling/insurance_providers/list`).then(res => {
            const data = res.data;
            const dt = !data ? {} : data;
            const arr = !dt.data ? [] : dt.data;
            const provArr = arr.map(item=>({value:`${item.provider_id}-${item.provider_type}-${item.provider_name}`, label:item.provider_name}))
            setProviders(provArr);
        }).catch(err => {
            logoutErrorMessage(err,null,actions)
        })
    }, []);

    const handleChangeInsuranceStatus = (event) =>{
        setInsuranceStatus(event.target.value)
    }

    const handleChangeInsuranceScheme = (value) =>{
        setInsuranceScheme(value)
    }


    const fetchInsuranceSchemes = (_id) =>{
        const insurance_id = _id.split('-')[0]
        const ins_id = Number(insurance_id)
        axios.get(`${config.smsUrl}/insurance-scheme/insurance-provider/${ins_id}`)
            .then(res => {
                const details = res.data;
                const dt = details ? details : []
                const arr = dt.map(item=>({
                    value:item.id,
                    label:item.name
                }))
                setInsuranceSchemes(arr)

            }).catch(error => {
            logoutErrorMessage(error, null, actions)
        })
    }


    const fetchPatientDetails = (patientNumber) =>{
        const formData = new FormData()
        formData.append('patient_number', patientNumber);
        axios.post(`${config.smsUrl}/cdoctor/get_patient_details`, formData)
            .then(res => {
                const data = res.data;
                const details = !data ? {} : data;
                const {first_name, last_name} = details;
                const provider_id = details.provider_id ? `${details.provider_id}-${details.provider_type}-${details.provider_name}` : ''
                const provider_name = details.provider_id ? details.provider_name : ''

                setProviderId({value:provider_id, label:provider_name})
                setIsProvider(provider_id)

                if (provider_id){
                    fetchInsuranceSchemes(provider_id)
                }
                setProviderDetails({account_name: details.account_name ? details.account_name : '',
                    card_number: details.card_number ? details.card_number : '',provider_type: details.provider_type ? details.provider_type : ''})
                setPatientName(`${!first_name ? "" : first_name} ${!last_name ? "" : last_name}`)
            }).catch(error => {
            errorMessages(error,null, actions)
        })
    }

    useEffect(()=>{
        if (!patient_number){
            return;
        }

        fetchPatientDetails(patient_number);

        if (visit_id) {
            const formData2 = new FormData();
            formData2.append('visit_id', visit_id);
            axios.post(`${config.smsUrl}/cdoctor/retrieve_exam_notes`, formData2).then(res => {
                const data = res.data;
                const dt = !data ? [] : data;
                const not = dt[dt.length-1] ? dt[dt.length-1] : {};
                const arr = not.notes ? not.notes : ''
                console.log(arr)
                if (arr){
                    setAdmissionNotes(arr);
                }
            }).catch(err => {
                errorMessages(err, null, actions)
            })
        }
    },[ patient_number]);

    const handleChange = event => {
        const {name, value} = event.target;
        setState({...state, [name]: value})
        const obj = {[visit_id]:{...note_item,[name]:value}}
        sessionStorage.setItem(`${user_roles_id}_${visit_id}`, JSON.stringify({...item, ...obj}))
    };

    const handleChangeRelationship = value =>{
        setRelationship(value)
        const obj = {[visit_id]:{...note_item,relationship:value}}
        sessionStorage.setItem(`${user_roles_id}_${visit_id}`, JSON.stringify({...item, ...obj}))
    }


    const handleChangeProvider = (value) =>{
        setProviderId(value)
        setNewProviderDetails({account_name: '', card_number: ''})
    }

    const handleChangeProviderDetails = (event) =>{
        const {name, value} = event.target
        setProviderDetails({...providerDetails, [name]:value})
    }

    const handleClosePrintDialog = () => {
        setOpenPrintDialog(false)
    };


    const handleOpenAssignBed = () =>{

        const {account_name, card_number} = providerDetails
        const [_, provider_type] = provider_id?.value?.split('-')

        const isInsurance = provider_type === 'Insurance Company'


        const schemeIds = [insurance_scheme].map(item=>({
            scheme_id:item.value
        }))

        const required_data = (isProvider && ((isInsurance && account_name && card_number && insurance_status && schemeIds.length > 0) || (!isInsurance && account_name))) || !isProvider
        const required_insurance = (isOnInsurance && required_data) || !isOnInsurance

        setSubmitted(true)
        if (match.patient_number && admission_date && required_insurance && findings) {
            setOpenAssignBed(true)
        }
    }

    const handleCloseAssignBed = () =>{
        setOpenAssignBed(false)
    }


    const handleSubmit = event => {
        event.preventDefault();
        const {account_name, card_number} = providerDetails
        const [id, provider_type] = provider_id?.value?.split('-')

        const isInsurance = provider_type === 'Insurance Company'


        const schemeIds = [insurance_scheme].map(item=>({
            scheme_id:item.value
        }))

        const data={
            patient_number: match.patient_number,
            visit_id: visit_id,
            patient_type: 2,
            department_id: department_id,
            first_name,
            relationship: relationship ? relationship.value : '',
            phone_no: contact ?  convertPhone(contact):contact,
            address, nin,
            user_roles_id: user_roles_id,
            provider_id: +id,
            is_on_insurance: isOnInsurance ? 1 : 0,
            account_name: account_name,
            card_number: card_number,
            scheme_id:schemeIds.length > 0 ? schemeIds : '',
            insurance_scheme_status:insurance_status ? insurance_status : '',
            findings: findings,
            bill_type:3,
            sundries:[],
            products: prescription.filter(item => Boolean(item)).filter(drug => drug.product_id).map(item=>({...item, quantity_prescribed: +item.quantity})),
            other_products:others ? others.filter(item=>Boolean(item)).filter(drug => drug.other_medicine || drug.dosage || drug.price || drug.instructions ||
                drug.frequency || drug.number_of_days) : [],
            is_referred: false,
            referral_data: ''
        }
        setSubmitted(true);

        const required_data = (isProvider && ((isInsurance && account_name && card_number && insurance_status && schemeIds.length > 0) || (!isInsurance && account_name))) || !isProvider
        const required_insurance = (isOnInsurance && required_data) || !isOnInsurance



        if (required_insurance && findings!=='') {
            setIsSubmitted('pending');
            axios.post(`${config.smsUrl}/cadmission/add_admission`, data).then(res => {
                setIsSubmitted('resolved');
                const data = res.data;
                const dt = !data ? {} : data;
                if(dt.message === "Already Exists"){
                    actions.snackbarActions.snackError("Patient already admitted");
                }else{
                    const admission_id = !dt.patient_admission_id ? "" : dt.patient_admission_id;
                    actions.snackbarActions.snackSuccess("Patient admission registered successfully");
                    if (admission_id){
                        setAdmissionId(admission_id)
                        setOpenDialog(true)
                        setOpenAssignBed(false)
                    }
                }
                sessionStorage.removeItem(`${user_roles_id}_${visit_id}`)
                handleReset();
                setSubmitted(false);
            }).catch(err => {
                setSubmitted(false);
                setIsSubmitted('rejected');
                errorMessages(err, null, actions)
            })
        }
    };

    const handleReset = () => {
        setState({
            admission_date: "",
            first_name: "",
            last_name: "",
            address: '',
            nin: ''
        });
        setContact('');
        setRelationship('');
        setState({admission_date: dateConvert(),
            first_name: "", last_name: "",  address: '', nin: ''
        });
    };


    const handleClick = () => {
        history.push(`/admissiontemplate/${patient_admission_id}/${visit_id}`)
    };


    // hooks for the admission notes
    const handleChangeNotes = (event) => {
        const _note = event.target.value;
        setAdmissionNotes(_note);
        const obj = {[visit_id]:{...note_item,notes:_note}}
        sessionStorage.setItem(`${user_roles_id}_${visit_id}`, JSON.stringify({...item, ...obj}))

    }

    const handlePrescriptionToggle = (event) => {
        setAddPrescription(event.target.checked);
    };

    const isPending = isSubmitted === 'pending';


    const providerProps = {submitted,provider_id,handleChangeProvider,providers,handleChangeProviderDetails, providerDetails}
    const isInsuranceProvider = providerDetails?.provider_type === "Insurance Company"



    const buttons = (
        <>
            <button type='button' onClick={handleSubmit} disabled={isPending} className='sms-info-btn btn-sm btn small-btn px-2 mr-3'>Yes</button>
            <button type='button' onClick={handleCloseAssignBed} className='sms-gray-btn btn btn-sm small-btn px-2'>No</button>
        </>

    )

    return(
        <form autoComplete="off">
            <FullScreenDialog open={openDialog} handleClose={()=>setOpenDialog(false)} title="Assign Bed">
                <AssignBed {...{setOpenDialog, isSubmitted, setIsSubmitted, actions,match:{patient_name, visit_id, patient_admission_id},
                    navigate:()=>{
                        history.push(`/admissiontemplate/${patient_admission_id}/${visit_id}`)
                    }}}/>
            </FullScreenDialog>
            <CustomDialog open={openAssignBed} buttons={buttons} handleClose={handleCloseAssignBed} title='Assign bed'>
                <p style={{textAlign:'center'}}>Would you like to assign a bed to this patient?</p>
            </CustomDialog>
            <PrintDialog message="Admission Form" openDialog={printDialog} handleClose={handleClosePrintDialog}
                         text="Would you like to view and print this admission form" handleClick={handleClick}
                         handleCancel={handleClosePrintDialog}/>

            <div>
                <Form.Group as={Row}>
                    <Col xs={12} sm={12} md={12} lg={3} xl={3}>
                        <Label name="Guardian(care taker)  Name"/>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                        <TextField onChange={handleChange} name="first_name" value={titleCase(first_name)} type="text"
                        />
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Col xs={12} sm={12} md={12} lg={3} xl={3}>
                        <Label name="Guardian(care taker) Contact"/>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                        <ReusablePhoneInput contact={contact} setContact={setContact}/>
                    </Col>
                </Form.Group>
            </div>

            <div>
                <Form.Group as={Row}>
                    <Col xs={12} sm={12} md={12} lg={3} xl={3}>
                        <Label name="Guardian(care taker) Address"/>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                        <ResizableTextarea onChange={handleChange} placeholder='Write address...' name="address"
                                           value={address}
                                           rows={2}
                        />
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Col xs={12} sm={12} md={12} lg={3} xl={3}>
                        <Label name="Relationship"/>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                        <CustomSelect value={relationship} onChange={handleChangeRelationship}
                                      options={[{value: 'Mother', label: 'Mother'}, {value: 'Father', label: 'Father'},
                                          {value: 'Wife', label: 'Wife'}, {value: 'Husband', label: 'Husband'},
                                          {value: 'Sister', label: 'Sister'}, {value: 'Brother', label: 'Brother'},
                                          {value: 'Spouse', label: 'Spouse'}, {value: 'Guardian', label: 'Guardian'},
                                          {value: 'Other', label: 'Other'}]} id='kin_relationship'/>
                    </Col>
                </Form.Group>
                {isOnInsurance && isProvider ?
                    <ProviderForm {...{...providerProps, isDisabled: true, labelSm: "3", colSm: "6"}}/> : null}
                {isOnInsurance && isInsuranceProvider ? <>
                    <Form.Group as={Row}>
                        <Col xs={12} sm={12} md={12} lg={3} xl={3}>
                            <Label name="Insurance scheme" type/>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                            <CustomSelect onChange={handleChangeInsuranceScheme} id='insurance_scheme'
                                          value={insurance_scheme}
                                          options={insuranceSchemes}/>
                            {submitted && insurance_scheme.length === 0 ?
                                <ErrorMessage>Insurance scheme is required</ErrorMessage> : null}
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                        <Col xs={12} sm={12} md={12} lg={3} xl={3}>
                            <Label name="Insurance status" htmlFor="insurance_status" type/>
                        </Col>

                        <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                            <Form.Check type="radio" inline label="On-smart" name="insurance_status" value="ON_SMART"
                                        checked={insurance_status === "ON_SMART"} id="on_smart"
                                        onChange={handleChangeInsuranceStatus} data-testid="insurance_status"/>
                            <Form.Check type="radio" inline label="Off-smart" name="insurance_status" value="OFF_SMART"
                                        checked={insurance_status === "OFF_SMART"} id="off_smart"
                                        onChange={handleChangeInsuranceStatus} data-testid="insurance_status"/>
                            {submitted && !insurance_status ?
                                <ErrorMessage>Insurance status is required</ErrorMessage> : null}
                        </Col>
                    </Form.Group>

                </> : null}
            </div>


            <div>
                <div className="switch-admission-prescription">
                    <Label name="Do you want to add a prescription?" className="label-admission-prescription"
                           style={{paddingLeft: '15px'}}/>
                    <text className="label-admission-prescription">No</text>
                    <Form.Check type="switch" id="custom-switch" defaultChecked={isAddPrescription}
                                onChange={handlePrescriptionToggle} className="toggle-admission-prescription"/>
                    <text className="label-admission-prescription">Yes</text>
                </div>
                {isAddPrescription ?  <NewPrescriptionTable {...addProps}/> : null}
            </div>

            <div>
                <Form.Group as={Row}>
                    <Form.Group as={Col}>
                        <FormLabel className="pl-0" name='Admission Notes' htmlFor="admission_notes" isRequired
                                   toolTip='Enter Admission Notes Here '/>
                        {submitted && (findings.trim().length === 0) ?
                            <ErrorMessage>Please enter admission notes</ErrorMessage> : null}
                        <ResizableTextarea submitted={submitted} id="admission_notes" rows="5" value={findings}
                                           name="notes" onChange={handleChangeNotes}/>
                    </Form.Group>
                </Form.Group>
            </div>
            <button type="button" onClick={handleOpenAssignBed} className="btn btn-sm sms-btn px-4"
                    data-testid="submitAdmissionForm">Save
            </button>
        </form>
    )
}